import { styled } from '@mui/material';

export const PageContainer = styled('section')`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 8px 12px 12px;
`;
